import { Personal } from '@modules/campaign/pages/personal/store/store.entity';
import { ACTIVITY_TYPES, QUESTION_TYPE } from '@core/constants/activities';
import {
  SupervisorFieldType,
  SupervisorFormType,
} from '../constants/activities';

export interface QuestionWritable {
  type: QUESTION_TYPE.PARAGRAPH | QUESTION_TYPE.SHORT_ANSWER;
  title: string;
}

export interface QuestionOptions {
  type: QUESTION_TYPE.MULTIPLE_OPTION | QUESTION_TYPE.UNIQUE_OPTION;
  title: string;
  options: string[];
}

export interface QuestionPicture {
  type: QUESTION_TYPE.PICTURE;
  quantity: number;
}

export type Question =
  | (QuestionWritable | QuestionOptions | QuestionPicture) & { id?: string };

export interface Survey {
  type: ACTIVITY_TYPES.SURVEY;
  name: string;
  amount: number;
  questions: Question[];
}

export interface Award {
  type: ACTIVITY_TYPES.AWARDS;
  items: { name: string; quantity: string; picture: boolean }[];
}

export interface Invoice {
  type: ACTIVITY_TYPES.INVOICES;
  pictureQuantity: number;
}

export interface TourItems {
  name: string;
  observation: string;
  address: string;
  latitude: number;
  longitude: number;
  id: string;
  complete?: boolean;
}

export interface Tour {
  type: ACTIVITY_TYPES.TOURS;
  items: TourItems[];
}

export type Activity = Survey | Award | Invoice | Tour;

export type StoredActivity = {
  type: any;
  id: number;
  name?: string;
  campaign_id: number | string;
  complete: number;
  progress: number;
  amount: number;
  is_complete: boolean
  activity_type: ACTIVITY_TYPES;
  data: Partial<{ survey_id: number } | Award | Invoice | Tour | Survey>;
};

export interface SaveActivityRq {
  config_activity_id: number;
  campaign_id: number | string;
  user_id: number | string;
  activity_type: ACTIVITY_TYPES;
  data: Record<string, any>;
}

export interface SupervisorActivity {
  id: number;
  campaign_id: number;
  name: string;
  type_form: SupervisorFormType;
  data: {
    type: SupervisorFieldType;
    Title: string;
    Options: string[];
  }[];
}

export interface StoreData {
  activities: StoredActivity[];
  supervisorActivities: SupervisorActivity[];
  selectedActivity?: StoredActivity | SupervisorActivity;
  selectedPersonal?: Personal;
}

export interface StoreActions {
  getCampaignActivities: (campaignId: number | string) => void;
  setSelectedActivity: (activity?: StoredActivity | SupervisorActivity) => void;
  setSelectedPersonal: (personal: Personal) => void;
  getSupervisorForms: () => void;
  resetSelectPersonal: () => void;
  reset: () => void;
}

export type ActivitiesState = StoreData & StoreActions;

export const initialState: StoreData = {
  activities: [],
  supervisorActivities: [],
};
